<template>
  <div class="page withdraw-preview">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true">预览提现</navigation>

    <!-- 预览信息 -->
    <section class="card-panel">
      <nd-cell
        class="info-line"
        :arrow="false"
        title="提现金额 (元)"
      ><span slot="text" style="color: #FF3446">{{loanPrin|currency}}</span></nd-cell>

      <nd-cell
        class="info-line"
        :arrow="false"
        title="分期期数"
        :text="`${loanTerm}期`"
      ></nd-cell>

      <nd-cell
        class="info-line"
        :arrow="false"
        title="用途"
        :text="purposeText"
      ></nd-cell>

      <nd-cell
        class="info-line shine"
        title="收款银行卡"
        :text="`${cardText}`"
        @click="goBankCard"
      ></nd-cell>

      <div v-if="loanProcess === 'GVIP'" class="info-bvip" :class="{shine: checkGreatVIP === 'N'}">
        <div class="bvip-title">
          <div style="display: flex; align-items: center;" @click="checkGreatVIP = checkGreatVIP === 'Y' ? 'N' : 'Y'">
            <img v-if="checkGreatVIP == 'Y'" src="./image/circle_02@2x.png" class="title-img">
            <img v-else src="./image/circle_02_no@2x.png" class="title-img">
            <span>大权益补贴</span>
            <img src="./image/icon_info@2x.png" class="title-tips" @click.stop="bvipVisible = true">
          </div>
          <div class="title-info">
            <span>{{greatVIPCoupon.termAmount | currency}}元/期</span>
            （共{{greatVIPCoupon.countTerm}}期）
          </div>
        </div>
        <div class="bvip-info">畅享专属特权大礼包，最高价值{{greatVIPCoupon.maxAmount}}元</div>
        <div class="bvip-tips">注：99%的用户选择了该权益</div>
      </div>

      <div class="info-other">
        <p class="other-title">其他借款信息</p>
        <template v-if="maxIntRate&&maxInterestFee">
          <p class="other-money">应还总息费(元)：<span class="through">¥{{maxInterestFee| currency}}</span><span>¥{{interestFee | currency}}</span></p>
          <p class="other-rate">综合年化利率(单利计算)：<span class="through">{{maxIntRate * 100| currency}}%</span><span >{{intRate * 100 | currency}}%</span>
            <img class="other-img" @click="handleShowTips" src="./image/icon_info@3x.png" alt="">
          </p>
        </template>
        <template v-else>
          <p class="other-money">应还总息费(元)：¥{{interestFee | currency}}</p>
          <p class="other-rate">综合年化利率(单利计算)：{{intRate * 100 | currency}}%
            <img class="other-img" @click="handleShowTips" src="./image/icon_info@3x.png" alt="">
          </p>
        </template>
      </div>
    </section>

    <div class="repayment-schedule a" v-if="showCase === 'A'">
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
      </div>

      <div class="schedule-list">
        <table>
          <thead>
            <tr class="table-header">
              <th width="35%">到期日</th>
              <th width="20%">期数</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr
              class="table-row"
              v-for="(item, index) in termInfo"
              :key="index"
            >
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.termNo }}/{{ termInfo.length }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="repayment-schedule b" v-else>
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
        <div class="show-detail" @click="toggle">{{ showDetail ? '收起详情': '查看详情'}}
          <img
            :style="{transform: showDetail?'rotate(-180deg)':'rotate(0deg)'}"
            src="./image/icon_01.png"
            srcset="
                            ./image/icon_01@2x.png 2x,
                            ./image/icon_01@3x.png,
                            3x
                        "
          />
        </div>
      </div>

      <div class="schedule-list" v-show="showDetail">
        <table>
          <thead>
            <tr class="table-header">
              <th width="35%">到期日</th>
              <th width="20%">期数</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr
              class="table-row"
              v-for="(item, index) in termInfo"
              :key="index"
            >
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.termNo }}/{{ termInfo.length }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 立即提现区域 -->
    <section class="bottom">
      <!-- 相关协议 -->
      <nd-button
        class="withdraw-btn"
        :disabled="!selectedBankcard.hasOwnProperty('bankCardNo') || (loanProcess === 'GVIP' && greatVIPCoupon.mustCheck && checkGreatVIP === 'N')"
        @click="beforeWithdraw"
      >立即提现</nd-button>
      <section class="read-protocol">
        <span>点击「立即提现」按钮，表示您已阅读并同意<em
          @click.stop="viewProtocol"
        >《相关协议》</em></span>
      </section>
    </section>

    <!-- 提现短信验证码 -->
    <nd-sms
      :duration="120"
      :showMobile="false"
      :tips="smsTips"
      title="短信认证"
      v-model="smsVisible"
      @retrieve="sendSmsAgain"
      @confirm="confirmWithdraw"
      @countEnd="countEnd"
      :errorTip="errorTip"
    ></nd-sms>

    <!-- 强弹征信协议 -->
    <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="greyShow?false:true" @close="closeBtn">
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="authenticationProtocol" frameborder="0"></iframe>
      </div>
      <div class="btn-wrapper">
        <nd-button v-if="!greyShow" class="btn" @click="agreeAuthentication">我已完成阅读并同意上述协议</nd-button>
        <nd-button v-if="greyShow" :disabled="COUNT_DOWN > 0" class="btn" @click="agreeAuthentication">我已阅读并同意上述协议{{countdownSubfix}}</nd-button>
      </div>
    </nd-dialog>
        
    <nd-dialog
      v-model="rateTipsVisible"
      closeBtn
      :footer="false"
    >
      <div class="rate-tips-title">综合年化利率说明</div>
      <div class="rate-tips-dialog">
        <p>该笔订单1年内用户需要承担的综合费用占本金的比率，1年以12个月计算。</p>
      </div>
    </nd-dialog>
    <bvip-intro-dialog v-model="bvipVisible" :content="greatVIPCoupon.couponPopupDesc"></bvip-intro-dialog>
  </div>
</template>
<script>
import NdSms from '../bankcard/components/nd-sms'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getKey, isEmptyObject } from '../../assets/utils'
import BvipIntroDialog from './components/bvip-intro-dialog.vue'
export default {
  name: 'withdraw-preview',

  description: '提现预览',

  components: {
    NdSms,
    BvipIntroDialog
  },

  customReadyNotify: true,

  data () {
    return {
      messageTips: '您正在执行提现操作，提现验证码已发送您的手机，请查收',
      fundCode: this.$route.query.fundCode,
      needLiveDetection: false, // 是否需要活体认证
      isPass: false, // 是否通过活体认证
      termInfo: [], // 还款试算
      smsVisible: false, // 是否显示短信验证码弹出框
      errorTip: '', // 短信验证码后端错误提示
      form: {
        // 提现表单
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      selectedBankcard: {},
      loanTerm: '',
      bankcardList: [], // 银行卡列表
      schdAmt: '', // 还款总额
      loanPrin: '', // 还款本金
      loanApplyNo: '',
      interestFee: 0,
      intRate: 0,
      maxIntRate: 0,
      maxInterestFee: 0,
      canSendSms: true,
      showDetail: false,
      authenticationVisible: false,
      authenticationProtocol: '', 
      greyShow: false, // 用来展示是否是灰度 包含大兴安岭资方灰度测试（不可点击
      COUNT_DOWN: 10,
      timer: null,
      rateTipsVisible: false,
      xiaomeiVIPArray: [], // 传递给小美VIP界面的数据
      isShowVIP: true, // 是否显示小美vip
      couponSerialNos: this.$route.query.couponSerialNos, // 券包运营活动跳转过来的券号
      couponType: this.$route.query.couponType, // 券包运营活动跳转过来的类型
      currentXiaomeiSelect: [], // 券包跳转默认旋转的券
      loanProcess: '', // 大权益开关，如果为GVIP则为开，从试算带过来的
      checkGreatVIP: 'Y', // 选择大权益
      bvipVisible: false
    }
  },

  watch: {
    smsVisible (value) {
      if (value) {
        this.$report({
          id: 10093,
          args: {
            visible: 1
          }
        })
      } else {
        this.$report({
          id: 10093,
          args: {
            visible: 0
          }
        })
      }
    },
    // 监听大权益的勾选，弹出toast
    checkGreatVIP (value) {
      // 监听大权益勾选，需要重置短信验证码
      this.canSendSms = true
      if (this.loanProcess === 'GVIP' && this.greatVIPCoupon.mustCheck && value === 'N') {
        this.$message('今日额度已抢完')
      }
    }
  },

  computed: {
    ...mapState('withdraw', {
      loanParameter: (state) => state.loanParameter,
      withdrawForm: (state) => state.withdrawForm
    }),

    ...mapState('user', ['userInfo']),
    xiaomeiMoney () {
      let number = 0
      this.xiaomeiVIPArray.map(item => {
        if (item.isSelected) {
          number = number + item.discountAmt
        }
      })
      return number
    },
    countdownSubfix () {
      if (this.COUNT_DOWN > 0) {
        return ` (${this.COUNT_DOWN}S)`
      }
      return ''
    },

    ...mapState({
      dictionary: (state) => state.dictionary
    }),

    cardText () {
      if (this.selectedBankcard.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName}(${code})`
      } else {
        return `去绑卡`
      }
    },

    purposeText () {
      if (isEmptyObject(this.dictionary)) return ''
      let purpose = this.dictionary.loanPurpose.filter(
        (pur) => pur.key === this.withdrawForm.purpose
      )[0]
      return purpose && purpose.description
    },

    smsTips () {
      return `<span>您正在执行提现操作，提现验证码已发送您的手机，请查收<em>${this.formatMobile(
        this.userInfo.mobile
      )}</em></span>`
    },

    clientWidth () {
      return document.documentElement.clientWidth + 'px'
    }
  },
  async created () {
    // 判断活体是否通过
    if (this.$route.query?.result === 'PASS') {
      this.isPass = this.$route.query.result === 'PASS'
      this.fundCode = this.$storage.get('fundCode')
    } else {
      this.isPass = false
    }

    this.generateWithdrawForm()
    this.getTermInfo()
    try {
      await Promise.all([
        this.getUserInfoX(),
        this.fetchDictionaryX(),
        this.getLoanParameter(),
        this.getBankcardList()
      ])
      this.$bus.$emit('ready')
      // 查看是否可自动提现
      this.canStartAutoWithdraw()
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  beforeRouteLeave (to, from, next) {
    this.setWithdrawForm(this.form)
    this.$storage.set('withdrawForm', this.form)
    if (!['/withdraw/xiaoMeiVIP', '/authentication/face', '/withdraw/protocol'].includes(to.path)) {
      sessionStorage.removeItem('xiaomeiVIPArray')
    }
    next()
  },

  methods: {
    ...mapActions(['fetchDictionaryX']),

    ...mapActions('withdraw', [
      'getLoanParameterX',
      'loanApply2X',
      'loanConfirm2X'
    ]),

    ...mapActions('user', ['getUserInfoX']),

    ...mapMutations('withdraw', ['setWithdrawForm']),

    ...mapActions('bankcard', ['getBankcardListX']),
    // 小美money展示
    showXiaomei (value) {
      let money = ''
      if (this.xiaomeiVIPArray && this.xiaomeiVIPArray.length > 0) {
        if (value) {
          money = `返现¥${Number(value).toFixed(2)}`
        } else {
          money = `最高获取<span style="color:#FF4633">120</span>元会员红包`
        }
      } else {
        money = '暂无可用'
      }
                
      return money 
    },
    countdown () {
      this.timer = setInterval(() => {
        if (this.COUNT_DOWN < 1) {
          clearInterval(this.timer)
        } else {
          this.COUNT_DOWN--
        }
      }, 1000)
    },

    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        productCd: 'TMDP'
      })
      if (response.success && response.data.length > 0) {
        const bank = this.$store.state.bankcard.selectedBankcard
        const defaltBankFilter = response.data.filter(
          (item) => item.defalt
        )
        const defaltBank =
          defaltBankFilter.length > 0 ? defaltBankFilter[0] : null
        this.selectedBankcard = !isEmptyObject(bank) && response.data.filter(item => item.bankCardNo === bank.bankCardNo).length !== 0
          ? response.data.filter(item => item.bankCardNo === bank.bankCardNo)[0]
          : defaltBank || response.data[response.data.length - 1]
      }
    },

    // 获取是否需要活体
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD'
      })
      if (response.success) {
        this.needLiveDetection = response.data.needLiveDetection
      } else {
        throw new Error('获取借款参数失败')
      }
    },

    // 获取分期信息
    async getTermInfo () {
      const repayTrail = this.$storage.get('repayTrail')

      this.$set(this, 'termInfo', repayTrail.termInfo)
      this.schdAmt = repayTrail.schdAmt
      this.loanPrin = repayTrail.loanPrin
      this.loanTerm = repayTrail.loanTerm
      this.showCase = repayTrail.showCase
      this.interestFee = repayTrail.interestFee
      this.maxIntRate = repayTrail.maxIntRate
      this.maxInterestFee = repayTrail.maxInterestFee
      this.intRate = repayTrail.intRate
      this.loanProcess = repayTrail.loanProcess
      this.greatVIPCoupon = repayTrail.greatVIPCoupon || {}
      this.xiaomeiVIPArray = JSON.parse(sessionStorage.getItem('xiaomeiVIPArray')) || repayTrail.canUseCouponList || []
      this.xiaomeiVIPArray = this.xiaomeiVIPArray.map((item) => {
        if (item.couponRecordId === this.couponSerialNos && JSON.parse(sessionStorage.getItem('xiaomeiVIPArray') || '[]').length < 1) {
          item.isSelected = true
        }
        return item
      })
      this.isShowVIP = repayTrail.hasCanUseCoupon
      this.$report({
        id: 10115,
        args: {
          target: this.showCase
        }
      })
    },

    // 查看相关协议
    viewProtocol () {
      this.$router.push({
        path: '/withdraw/protocol',
        query: {
          fundCode: this.$route.query.fundCode,
          busiType: 'LOAN',
          loanProcess: this.loanProcess
        }
      })
    },

    // 获取提现表单数据，如果state没有就从本地缓存中获取，都没有页面就会报错
    generateWithdrawForm () {
      if (
        !isEmptyObject(this.withdrawForm) &&
        this.withdrawForm.applyAmt !== 0
      ) {
        this.form = this.withdrawForm
      } else {
        this.form = this.$storage.get('withdrawForm')
        this.setWithdrawForm(this.form)
      }
    },

    // 发起活体认证
    startAuth () {
      this.$storage.set('loanApplyNo', this.loanApplyNo)
      this.$storage.set('fundCode', this.$route.query.fundCode)
      this.$router.replace('/authentication/face?redirectUrl=/withdraw/preview')
    },
    // 获取优惠券id
    getCouponsId () {
      let arr = []
      let alreadySelect = []
      this.xiaomeiVIPArray.map(item => {
        if (item.isSelected) {
          arr.push(item.couponRecordId)
          alreadySelect.push(item)
        }
      })
      if (alreadySelect.length && alreadySelect.filter(item => item.memberCouponType === this.couponType || item.couponSerialNos === this.couponSerialNos).length < 1) {
        arr.push(this.couponSerialNos)
      }
      if (arr.length > 0) {
        return { couponSerialNos: arr }
      } else {
        return {}
      }
    },
    // 短信失效或者错误 - 再次发起申请
    async sendSmsAgain (reset) {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      let couponSerialNos = this.getCouponsId()
      const params = {
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        applyAmount: this.loanPrin,
        loanPurpose: this.withdrawForm.purpose,
        totatlTermNo: this.loanTerm,
        bindCardDto: this.selectedBankcard,
        loanProcess: this.loanProcess,
        ...couponSerialNos,
        ...trafficCode
      }
      if (this.loanProcess === 'GVIP') {
        params.checkGreatVIP = this.checkGreatVIP
      }
      const response = await this.loanApply2X(params)
      if (response.success) {
        this.loanApplyNo = response.data.loanApplyNo
        this.canSendSms = false
        reset()
      } else {
        if (response.code === '000028') {
          this.loanApplyNo = response.msg
          this.canSendSms = false
          reset()
        } else {
          this.$message(response.msg)
        }
      }
    },

    // 点击提现
    beforeWithdraw () {
      const fundRoute = this.$storage.get('fundRoute')
      if (fundRoute.forceReads && fundRoute.forceReads.length > 0) {
        this.authenticationProtocol = fundRoute.forceReads[0].contractUrl
        // if (this.authenticationProtocol.includes('/protocol/tmd/by/index')) {
        //     const { loanPrin, purposeText, loanTerm } = this
        //     this.authenticationProtocol = `${this.authenticationProtocol}?loanPrin=${loanPrin}&purposeText=${purposeText}&loanTerm=${loanTerm}&bankCardNo=${this.selectedBankcard.bankCardNo}&token=${getKey('userInfo', 'token')}&contractName=${fundRoute.forceReads[0].contractName}&fundCode=${fundRoute.fundCode}&loanPlatform=TMD&device=${getKey('X-DEVICE-IF')}`
        // }
        this.greyShow = fundRoute.greyShow
        // this.greyShow = true
        this.authenticationVisible = true
        if (this.greyShow) {
          this.$report({
            id: 10171,
            args: {
              visible: 1
            }
          })
          this.COUNT_DOWN = 10
          this.countdown()
        } else {
          this.$report({
            id: 10175,
            args: {
              visible: 1
            }
          })
        }
        this.$nextTick(() => {
          this.$refs['authIframe'].contentWindow.postMessage({
            type: 'setFontSize',
            value: document.documentElement.style.fontSize
          }, '*')
        })
      } else {
        this.goWithdraw()
      }
    },

    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },

    agreeAuthentication () {
      this.$report({
        id: this.greyShow ? 10175 : 10172,
        args: {
          visible: 0
        }
      })
      this.$report({
        id: this.greyShow ? 10171 : 10174,
        args: {
          visible: 0
        }
      })
      this.authenticationVisible = false
      this.goWithdraw()
    },
    closeBtn () {
      this.$report({
        id: 10173
      })
    },
    goWithdraw () {
      this.$report({
        id: 10092
      })
      this.applyWithdraw()
    },

    // 倒计时结束可再次发送验证码
    countEnd () {
      this.canSendSms = true
    },

    // 重新绑卡
    reBindBankcard () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: 'loan',
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          productCd: 'TMDP',
          bankMobile: this.selectedBankcard.bankMobile,
          bankcardNo: this.selectedBankcard.bankCardNo,
          canChangePhoneNo: this.selectedBankcard.canChangePhoneNo
        }
      })
    },
    // 申请提现
    async applyWithdraw () {
      if (this.selectedBankcard.invalid) {
        return this.reBindBankcard()
      }
      this.errorTip = ''
      if (!this.canSendSms) {
        this.smsVisible = true
        return
      }
      // 全部完成 -> 去授信
      await this.riskReport(3)
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      let couponSerialNos = this.getCouponsId()
      const params = {
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        applyAmount: this.loanPrin,
        loanPurpose: this.withdrawForm.purpose,
        totatlTermNo: this.loanTerm,
        bindCardDto: this.selectedBankcard,
        loanProcess: this.loanProcess,
        ...couponSerialNos,
        ...trafficCode
      }
      if (this.loanProcess === 'GVIP') {
        params.checkGreatVIP = this.checkGreatVIP
      }
      const response = await this.loanApply2X(params)
      if (response.code === '100018') {
        this.reBindBankcard()
        return
      }
      if (response.success) {
        this.loanApplyNo = response.data.loanApplyNo
        if (this.needLiveDetection && !this.isPass) {
          return this.startAuth()
        }
        this.canSendSms = false
        this.smsVisible = true
      } else {
        if (response.code === '000028') {
          this.smsVisible = true
          this.canSendSms = false
          this.loanApplyNo = response.msg
        } else {
          this.$message(response.msg)
        }
      }
    },

    // 确认提现
    async confirmWithdraw (code = '') {
      if (code) {
        this.$report({
          id: 10094
        })
      }
      const response = await this.loanConfirm2X({
        loanApplyNo: this.loanApplyNo,
        smsCode: code,
        couponSerialId: this.$route.query.couponSerialId
      })
      if (response.success) {
        this.$report({
          id: 10112,
          args: {
            succeed: 1
          }
        })
        this.$statistics('WITH_SUB_SUC')
        this.$storage.remove('fundCode')
        // TODD
        if (getKey('channel') === 'API-XHQB') {
          window.location.href = response.data.jumpUrl
        } else {
          this.$router.replace(
            `/authentication/auditing?applyNo=${response.data.loanApplyNo}`
          )
        }
      } else {
        this.$statistics('WITH_SUB_FAIL', {
          comment: response.msg
        })
        if (response.code === '200001') {
          window.location.href = getKey('successUrl')
        }
        if (response.code === '000010') {
          this.errorTip = response.msg
          this.$report({
            id: 10112,
            args: {
              succeed: 0
            }
          })
        }
        if (response.code === '100007') {
          this.errorTip = response.msg
        }
      }
    },

    // 是否可以发起自动提现 - 活体认证返回
    canStartAutoWithdraw () {
      if (this.isPass) {
        this.loanApplyNo = this.$storage.get('loanApplyNo')
        this.confirmWithdraw()
      }
    },

    // 去绑卡
    goBankCard () {
      if (!isEmptyObject(this.selectedBankcard)) {
        this.$router.push({
          path: '/bankcard/list',
          query: {
            loanPlatform: 'TMD',
            fundCode: this.fundCode,
            productCd: 'TMDP'
          }
        })
      } else {
        this.$router.push({
          path: '/bankcard/add',
          query: {
            position: 'loan',
            loanPlatform: 'TMD',
            fundCode: this.fundCode,
            productCd: 'TMDP'
          }
        })
      }
    },
    // 跳转到小美vip
    jumpXiaoMeiVIP () {
      this.$report({
        id: 10231,
        args: {
        }
      })
      if (this.xiaomeiVIPArray.length > 0) {
        sessionStorage.setItem('xiaomeiVIPArray', JSON.stringify(this.xiaomeiVIPArray))
        this.$router.push({
          path: '/withdraw/xiaoMeiVIP',
          query: {
            fundCode: this.fundCode,
            couponSerialNos: this.couponSerialNos,
            couponType: this.couponType
          }
        })
      }
    },
    toggle () {
      this.showDetail = !this.showDetail
    },
    // 显示年化利率的弹窗
    handleShowTips () {
      this.rateTipsVisible = true
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

@keyframes shine {
    0% {
        background-color: #ffddd9;
    }
    20% {
        background-color: #ffffff;
    }
    40% {
        background-color: #ffddd9;
    }
    60% {
        background-color: #ffffff;
    }
    80% {
        background-color: #ffddd9;
    }
    100% {
        background-color: #ffffff;
    }
}
.through{
    text-decoration: line-through;
    padding-right:15px;
}
.withdraw-preview {
    padding-bottom: 325px;
    min-height: 100%;
    box-sizing: border-box;
    background-color: RGBA(250, 250, 250, 1);

    .card-panel {
        margin-top: 20px;

        .info-line {
            height: 100px;
            line-height: 100px;
            border-bottom: 1px solid #eee;
            position: relative;
            margin-bottom: 1px;
            font-size: 30px;
            color: rgba(51, 51, 51, 1) !important;
            &:last-child {
                animation: shine 2000ms step-end;
                // background-color: #FFDDD9 !important;
            }

            .custom-icon {
                display: block;
                width: 30px;
                height: 30px;
                /*background-image: url(../../assets/img/withdraw-preview/icon_explain@3x.png);*/
                background-size: 100%;
                float: right;
                position: relative;
                top: 35px;
                margin-left: 10px;
            }

            .weight {
                font-size: 34px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #20c7c7;
            }
        }
        .info-bvip{
          background: url(./image/img_shou@2x.png) 514px 50px no-repeat #fff;
          background-size: 220px 206px;
          margin-top: 20px;
          padding: 38px 20px 30px 40px;
          &.shine{
            animation: newShine 3000ms infinite;
          }
          .bvip-title{
            font-size: 30px;
            color: #333333;
            line-height: 50px;
            display: flex;
            align-items: center;
            font-weight: bold;
            .title-img{
              width: 32px;
              height: 32px;
              margin-right: 19px;
            }
            .title-tips{
              width: 24px;
              height: 24px;
              margin-left: 10px;
            }
            .title-info{
              margin-left: auto;
              span{
                color: #FF4633;
              }
            }
          }
          .bvip-info{
            font-size: 26px;
            color: #666666;
            line-height: 50px;
            padding-left: 50px;
          }
          .bvip-tips{
            font-size: 24px;
            color: #999999;
            line-height: 50px;
            padding-left: 50px;
          }
        }
        .info-other{
            width: 100%;
            background-color: #fff;
            margin-top: 21px;
            padding: 28px 30px;
            .other-title{
                color: #333333;
                font-size: 30px;
            }
            .other-money{
                color: #999999;
                font-size: 26px;
                margin-top: 15px;
            }
            .other-rate{
                color: #999999;
                font-size: 26px;
                margin-top: 10px;
                .other-img{
                    width: 26px;
                    height: 26px;
                    vertical-align: -3px;
                }
            }
        }
        .info-other{
            width: 100%;
            background-color: #fff;
            margin-top: 21px;
            padding: 28px 30px;
            .other-title{
                color: #333333;
                font-size: 30px;
            }
            .other-money{
                color: #999999;
                font-size: 26px;
                margin-top: 15px;
            }
            .other-rate{
                color: #999999;
                font-size: 26px;
                margin-top: 10px;
                .other-img{
                    width: 26px;
                    height: 26px;
                    vertical-align: -3px;
                }
            }
        }
    }
    .repayment-schedule {
        margin: 40px 30px 0;
        border-radius: 10px;
        &.b {
            background-color: #fff;
            .cell-title {
                padding: 33px 40px;
                .show-detail {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: rgba(142, 178, 216, 1);
                    line-height: 50px;
                    > img {
                        width: 29px;
                        height: 29px;
                        margin-left: 8px;
                        transition: all .3s;
                    }
                }
            }
        }
        .cell-title {
            font-size: 32px;
            line-height: 50px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            em {
                font-size: 26px;
                font-style: normal;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .schedule-list {
            margin-top: 22px;
            padding-bottom: 20px;
            background-color: #ffffff;
            border-radius: 10px;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 23px;
                        padding-bottom: 7px;
                        border-bottom: 1px solid @iuc;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 50px;
                        line-height: 50px;
                        font-size: 22px;
                        padding-top: 10px;
                        text-align: center;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }
                }
            }
        }
    }

    > .bottom {
        width: 750px;
        height: 230px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
        position: fixed;
        bottom: 0;
        .read-protocol {
            width: 100%;
            text-align: center;
            margin-top: 25px;
            span {
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #666;
                font-size: 24px;
                line-height: 33px;
                display: block;
                em {
                    font-style: normal;
                    color: rgba(142, 178, 216, 1);
                    margin-left: 5px;
                    margin-right: 5px;
                }
            }
        }
        .withdraw-btn {
            width: 650px;
            height: 94px;
            border-radius: 47px;
            margin: 30px auto 0;
        }
    }

    .auth-dialog {
        .default-content {
            width: 620px;
            border-radius: 30px 30px 0 0;
            padding-top: 40px;
            background: white;
            height: 638px;
            overflow: auto;
            .dialog-title {
                text-align: center;
                font-size: 36px;
                padding-bottom: 15px;
                font-weight: 600;
            }

            .dialog-footer {
                padding: 0 50px;
                padding-bottom: 40px;
                display: flex;
                justify-content: space-between;
                background-color: #FFFFFF;

                .btn {
                    width: 240px;
                    height: 80px;
                    line-height: 80px;
                }
            }
        }
        .iframe {
            height: 638px;
            width: 100%;

            html {
                width: 100%;
            }
        }

        .btn-wrapper {
            position: fixed;
            background: white;
            height: 162px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width:620px;
            border-radius:  0 0 30px 30px;
            transform: translateY(-20px);
            .btn {
                width: 500px;
            }
        }
    }
    /deep/ .rate-tips-title{
        font-size: 42px;
        color: #333333;
        font-weight: bold;
        padding-left: 40px;
    }
    .rate-tips-dialog{
        padding: 40px 40px 60px;
        color: #666666;
        font-size: 28px;
    }
}
</style>
